export default {
    loaded: "tournaments.loaded",
    unload: "tournaments.unload"
}